// SPDX-License-Identifier: AGPL-3.0-or-later

// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=none"
// @generated from file konvo/user/preferences/v1/preferences.proto (package konvo.user.preferences.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AccessibilityOverrides, AccessibilitySettings } from "./accessibility_pb";
import { file_konvo_user_preferences_v1_accessibility } from "./accessibility_pb";
import type { EmojiPickerState, EmojiState, EmojiStickerLayoutSettings, FavoriteGifSettings, MemesPickerState, SoundSettings, StickerPickerState } from "./pickers_pb";
import { file_konvo_user_preferences_v1_pickers } from "./pickers_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file konvo/user/preferences/v1/preferences.proto.
 */
export const file_konvo_user_preferences_v1_preferences: GenFile = /*@__PURE__*/
  fileDesc("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", [file_konvo_user_preferences_v1_accessibility, file_konvo_user_preferences_v1_pickers]);

/**
 * @generated from message konvo.user.preferences.v1.SyncedPreferences
 */
export type SyncedPreferences = Message<"konvo.user.preferences.v1.SyncedPreferences"> & {
  /**
   * @generated from field: konvo.user.preferences.v1.AccessibilitySettings accessibility = 1;
   */
  accessibility?: AccessibilitySettings | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.AccessibilityOverrides accessibility_overrides = 2;
   */
  accessibilityOverrides?: AccessibilityOverrides | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.TextualPreviewSettings textual_preview = 3;
   */
  textualPreview?: TextualPreviewSettings | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.EmojiPickerState emoji_picker = 20;
   */
  emojiPicker?: EmojiPickerState | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.StickerPickerState sticker_picker = 21;
   */
  stickerPicker?: StickerPickerState | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.MemesPickerState memes_picker = 22;
   */
  memesPicker?: MemesPickerState | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.EmojiState emoji = 23;
   */
  emoji?: EmojiState | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.EmojiStickerLayoutSettings emoji_sticker_layout = 24;
   */
  emojiStickerLayout?: EmojiStickerLayoutSettings | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.FavoriteGifSettings favorite_gifs = 25;
   */
  favoriteGifs?: FavoriteGifSettings | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.FavoritesState favorites = 40;
   */
  favorites?: FavoritesState | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.RecentMentionsSettings recent_mentions = 41;
   */
  recentMentions?: RecentMentionsSettings | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.SidebarPreferences sidebar = 42;
   */
  sidebar?: SidebarPreferences | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.MemberListState member_list = 43;
   */
  memberList?: MemberListState | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.UnreadChannelsState unread_channels = 44;
   */
  unreadChannels?: UnreadChannelsState | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.MentionFrecencyState mention_frecency = 45;
   */
  mentionFrecency?: MentionFrecencyState | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.NagbarDismissals nagbars = 60;
   */
  nagbars?: NagbarDismissals | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.DismissedUpsells dismissed_upsells = 61;
   */
  dismissedUpsells?: DismissedUpsells | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.GuildNsfwAgreements guild_nsfw_agreements = 62;
   */
  guildNsfwAgreements?: GuildNsfwAgreements | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.WhatsNewState whats_new = 63;
   */
  whatsNew?: WhatsNewState | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.PrivacyPreferences privacy = 80;
   */
  privacy?: PrivacyPreferences | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.LocalUserSpamOverrides local_spam_overrides = 81;
   */
  localSpamOverrides?: LocalUserSpamOverrides | undefined;

  /**
   * @generated from field: bool sanitize_urls = 82;
   */
  sanitizeUrls: boolean;

  /**
   * @generated from field: konvo.user.preferences.v1.SoundSettings sound = 100;
   */
  sound?: SoundSettings | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.SpellcheckSettings spellcheck = 101;
   */
  spellcheck?: SpellcheckSettings | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.SearchEngineSettings search_engines = 102;
   */
  searchEngines?: SearchEngineSettings | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.PermissionLayoutSettings permission_layout = 103;
   */
  permissionLayout?: PermissionLayoutSettings | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.GuildMemberLayoutSettings guild_member_layout = 104;
   */
  guildMemberLayout?: GuildMemberLayoutSettings | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.GuildFolderExpandedState guild_folders = 105;
   */
  guildFolders?: GuildFolderExpandedState | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.HiddenGuildListButtons hidden_guild_buttons = 106;
   */
  hiddenGuildButtons?: HiddenGuildListButtons | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.KeyboardModeIntroState keyboard_mode_intro = 107;
   */
  keyboardModeIntro?: KeyboardModeIntroState | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.InputMonitoringPromptsState input_monitoring = 108;
   */
  inputMonitoring?: InputMonitoringPromptsState | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.VoicePromptsState voice_prompts = 109;
   */
  voicePrompts?: VoicePromptsState | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.SudoPromptState sudo_prompt = 110;
   */
  sudoPrompt?: SudoPromptState | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.KeybindSettings keybinds = 111;
   */
  keybinds?: KeybindSettings | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.ChatInputSettings chat_input = 112;
   */
  chatInput?: ChatInputSettings | undefined;

  /**
   * @generated from field: optional bool save_camera_uploads_to_device = 113;
   */
  saveCameraUploadsToDevice?: boolean | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.TasksViewPreferences tasks_view = 114;
   */
  tasksView?: TasksViewPreferences | undefined;

  /**
   * Active Chats source filter. Unset means "all".
   *
   * @generated from field: optional string chats_filter = 115;
   */
  chatsFilter?: string | undefined;
};

/**
 * Describes the message konvo.user.preferences.v1.SyncedPreferences.
 * Use `create(SyncedPreferencesSchema)` to create a new message.
 */
export const SyncedPreferencesSchema: GenMessage<SyncedPreferences> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 0);

/**
 * KONVO: how the Tasks page is laid out. Synced so the view a person sets up on
 * one device is the one they get on the next.
 *
 * @generated from message konvo.user.preferences.v1.TasksViewPreferences
 */
export type TasksViewPreferences = Message<"konvo.user.preferences.v1.TasksViewPreferences"> & {
  /**
   * "location" | "due" | "none". Unset means the default (location).
   *
   * @generated from field: optional string group_by = 1;
   */
  groupBy?: string | undefined;

  /**
   * "list" | "board".
   *
   * @generated from field: optional string view = 2;
   */
  view?: string | undefined;

  /**
   * "mine" | "all".
   *
   * @generated from field: optional string scope = 3;
   */
  scope?: string | undefined;

  /**
   * Selected entry in the location nav; unset or "" means every location.
   *
   * @generated from field: optional string location_id = 4;
   */
  locationId?: string | undefined;

  /**
   * Group headers the person has collapsed, by group key.
   *
   * @generated from field: repeated string collapsed_group_ids = 5;
   */
  collapsedGroupIds: string[];
};

/**
 * Describes the message konvo.user.preferences.v1.TasksViewPreferences.
 * Use `create(TasksViewPreferencesSchema)` to create a new message.
 */
export const TasksViewPreferencesSchema: GenMessage<TasksViewPreferences> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 1);

/**
 * @generated from message konvo.user.preferences.v1.SpellcheckSettings
 */
export type SpellcheckSettings = Message<"konvo.user.preferences.v1.SpellcheckSettings"> & {
  /**
   * @generated from field: optional bool enabled = 1;
   */
  enabled?: boolean | undefined;

  /**
   * @generated from field: repeated string languages = 2;
   */
  languages: string[];

  /**
   * @generated from field: repeated string personal_dictionary = 3;
   */
  personalDictionary: string[];

  /**
   * @generated from field: optional bool auto_detect = 4;
   */
  autoDetect?: boolean | undefined;

  /**
   * @generated from field: optional string engine = 5;
   */
  engine?: string | undefined;
};

/**
 * Describes the message konvo.user.preferences.v1.SpellcheckSettings.
 * Use `create(SpellcheckSettingsSchema)` to create a new message.
 */
export const SpellcheckSettingsSchema: GenMessage<SpellcheckSettings> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 2);

/**
 * @generated from message konvo.user.preferences.v1.SearchEngineSettings
 */
export type SearchEngineSettings = Message<"konvo.user.preferences.v1.SearchEngineSettings"> & {
  /**
   * @generated from field: optional string text_search_engine_id = 1;
   */
  textSearchEngineId?: string | undefined;

  /**
   * @generated from field: optional string reverse_image_search_engine_id = 2;
   */
  reverseImageSearchEngineId?: string | undefined;

  /**
   * @generated from field: optional string translation_provider_id = 3;
   */
  translationProviderId?: string | undefined;
};

/**
 * Describes the message konvo.user.preferences.v1.SearchEngineSettings.
 * Use `create(SearchEngineSettingsSchema)` to create a new message.
 */
export const SearchEngineSettingsSchema: GenMessage<SearchEngineSettings> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 3);

/**
 * @generated from message konvo.user.preferences.v1.PrivacyPreferences
 */
export type PrivacyPreferences = Message<"konvo.user.preferences.v1.PrivacyPreferences"> & {
  /**
   * @generated from field: bool disable_stream_previews = 1;
   */
  disableStreamPreviews: boolean;

  /**
   * @generated from field: optional bool show_active_now = 2;
   */
  showActiveNow?: boolean | undefined;

  /**
   * @generated from field: optional bool preupload_message_attachments = 3;
   */
  preuploadMessageAttachments?: boolean | undefined;
};

/**
 * Describes the message konvo.user.preferences.v1.PrivacyPreferences.
 * Use `create(PrivacyPreferencesSchema)` to create a new message.
 */
export const PrivacyPreferencesSchema: GenMessage<PrivacyPreferences> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 4);

/**
 * @generated from message konvo.user.preferences.v1.LocalUserSpamOverrides
 */
export type LocalUserSpamOverrides = Message<"konvo.user.preferences.v1.LocalUserSpamOverrides"> & {
  /**
   * @generated from field: repeated string spammer_user_ids = 1;
   */
  spammerUserIds: string[];

  /**
   * @generated from field: repeated string not_spammer_user_ids = 2;
   */
  notSpammerUserIds: string[];
};

/**
 * Describes the message konvo.user.preferences.v1.LocalUserSpamOverrides.
 * Use `create(LocalUserSpamOverridesSchema)` to create a new message.
 */
export const LocalUserSpamOverridesSchema: GenMessage<LocalUserSpamOverrides> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 5);

/**
 * @generated from message konvo.user.preferences.v1.TextualPreviewSettings
 */
export type TextualPreviewSettings = Message<"konvo.user.preferences.v1.TextualPreviewSettings"> & {
  /**
   * @generated from field: bool wrap_text = 1;
   */
  wrapText: boolean;
};

/**
 * Describes the message konvo.user.preferences.v1.TextualPreviewSettings.
 * Use `create(TextualPreviewSettingsSchema)` to create a new message.
 */
export const TextualPreviewSettingsSchema: GenMessage<TextualPreviewSettings> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 6);

/**
 * @generated from message konvo.user.preferences.v1.SidebarPreferences
 */
export type SidebarPreferences = Message<"konvo.user.preferences.v1.SidebarPreferences"> & {
  /**
   * @generated from field: bool inline_dms_collapsed = 1;
   */
  inlineDmsCollapsed: boolean;

  /**
   * @generated from field: optional bool show_collapsed_unread_dms_badge = 2;
   */
  showCollapsedUnreadDmsBadge?: boolean | undefined;

  /**
   * @generated from field: optional bool show_incoming_friend_request_badge = 3;
   */
  showIncomingFriendRequestBadge?: boolean | undefined;
};

/**
 * Describes the message konvo.user.preferences.v1.SidebarPreferences.
 * Use `create(SidebarPreferencesSchema)` to create a new message.
 */
export const SidebarPreferencesSchema: GenMessage<SidebarPreferences> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 7);

/**
 * @generated from message konvo.user.preferences.v1.MemberListState
 */
export type MemberListState = Message<"konvo.user.preferences.v1.MemberListState"> & {
  /**
   * @generated from field: optional bool members_open = 1;
   */
  membersOpen?: boolean | undefined;
};

/**
 * Describes the message konvo.user.preferences.v1.MemberListState.
 * Use `create(MemberListStateSchema)` to create a new message.
 */
export const MemberListStateSchema: GenMessage<MemberListState> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 8);

/**
 * @generated from message konvo.user.preferences.v1.UnreadChannelsState
 */
export type UnreadChannelsState = Message<"konvo.user.preferences.v1.UnreadChannelsState"> & {
  /**
   * @generated from field: repeated string collapsed_channel_ids = 1;
   */
  collapsedChannelIds: string[];
};

/**
 * Describes the message konvo.user.preferences.v1.UnreadChannelsState.
 * Use `create(UnreadChannelsStateSchema)` to create a new message.
 */
export const UnreadChannelsStateSchema: GenMessage<UnreadChannelsState> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 9);

/**
 * @generated from message konvo.user.preferences.v1.RecentMentionsSettings
 */
export type RecentMentionsSettings = Message<"konvo.user.preferences.v1.RecentMentionsSettings"> & {
  /**
   * @generated from field: optional bool include_everyone = 1;
   */
  includeEveryone?: boolean | undefined;

  /**
   * @generated from field: optional bool include_roles = 2;
   */
  includeRoles?: boolean | undefined;

  /**
   * @generated from field: optional bool include_guilds = 3;
   */
  includeGuilds?: boolean | undefined;
};

/**
 * Describes the message konvo.user.preferences.v1.RecentMentionsSettings.
 * Use `create(RecentMentionsSettingsSchema)` to create a new message.
 */
export const RecentMentionsSettingsSchema: GenMessage<RecentMentionsSettings> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 10);

/**
 * @generated from message konvo.user.preferences.v1.MentionFrecencyState
 */
export type MentionFrecencyState = Message<"konvo.user.preferences.v1.MentionFrecencyState"> & {
  /**
   * @generated from field: repeated konvo.user.preferences.v1.MentionFrecencyState.Scope scopes = 1;
   */
  scopes: MentionFrecencyState_Scope[];
};

/**
 * Describes the message konvo.user.preferences.v1.MentionFrecencyState.
 * Use `create(MentionFrecencyStateSchema)` to create a new message.
 */
export const MentionFrecencyStateSchema: GenMessage<MentionFrecencyState> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 11);

/**
 * @generated from message konvo.user.preferences.v1.MentionFrecencyState.Entry
 */
export type MentionFrecencyState_Entry = Message<"konvo.user.preferences.v1.MentionFrecencyState.Entry"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: uint32 count = 2;
   */
  count: number;

  /**
   * @generated from field: int64 last_at_ms = 3;
   */
  lastAtMs: bigint;
};

/**
 * Describes the message konvo.user.preferences.v1.MentionFrecencyState.Entry.
 * Use `create(MentionFrecencyState_EntrySchema)` to create a new message.
 */
export const MentionFrecencyState_EntrySchema: GenMessage<MentionFrecencyState_Entry> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 11, 0);

/**
 * @generated from message konvo.user.preferences.v1.MentionFrecencyState.Scope
 */
export type MentionFrecencyState_Scope = Message<"konvo.user.preferences.v1.MentionFrecencyState.Scope"> & {
  /**
   * @generated from field: string guild_id = 1;
   */
  guildId: string;

  /**
   * @generated from field: repeated konvo.user.preferences.v1.MentionFrecencyState.Entry entries = 2;
   */
  entries: MentionFrecencyState_Entry[];
};

/**
 * Describes the message konvo.user.preferences.v1.MentionFrecencyState.Scope.
 * Use `create(MentionFrecencyState_ScopeSchema)` to create a new message.
 */
export const MentionFrecencyState_ScopeSchema: GenMessage<MentionFrecencyState_Scope> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 11, 1);

/**
 * @generated from message konvo.user.preferences.v1.FavoritesState
 */
export type FavoritesState = Message<"konvo.user.preferences.v1.FavoritesState"> & {
  /**
   * @generated from field: repeated konvo.user.preferences.v1.FavoriteChannel channels = 1;
   */
  channels: FavoriteChannel[];

  /**
   * @generated from field: repeated konvo.user.preferences.v1.FavoriteCategory categories = 2;
   */
  categories: FavoriteCategory[];

  /**
   * @generated from field: repeated string collapsed_category_ids = 3;
   */
  collapsedCategoryIds: string[];

  /**
   * @generated from field: bool hide_muted_channels = 4;
   */
  hideMutedChannels: boolean;

  /**
   * @generated from field: bool muted = 5;
   */
  muted: boolean;
};

/**
 * Describes the message konvo.user.preferences.v1.FavoritesState.
 * Use `create(FavoritesStateSchema)` to create a new message.
 */
export const FavoritesStateSchema: GenMessage<FavoritesState> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 12);

/**
 * @generated from message konvo.user.preferences.v1.FavoriteChannel
 */
export type FavoriteChannel = Message<"konvo.user.preferences.v1.FavoriteChannel"> & {
  /**
   * @generated from field: string channel_id = 1;
   */
  channelId: string;

  /**
   * @generated from field: string guild_id = 2;
   */
  guildId: string;

  /**
   * @generated from field: optional string parent_id = 3;
   */
  parentId?: string | undefined;

  /**
   * @generated from field: int32 position = 4;
   */
  position: number;

  /**
   * @generated from field: optional string nickname = 5;
   */
  nickname?: string | undefined;
};

/**
 * Describes the message konvo.user.preferences.v1.FavoriteChannel.
 * Use `create(FavoriteChannelSchema)` to create a new message.
 */
export const FavoriteChannelSchema: GenMessage<FavoriteChannel> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 13);

/**
 * @generated from message konvo.user.preferences.v1.FavoriteCategory
 */
export type FavoriteCategory = Message<"konvo.user.preferences.v1.FavoriteCategory"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: int32 position = 3;
   */
  position: number;
};

/**
 * Describes the message konvo.user.preferences.v1.FavoriteCategory.
 * Use `create(FavoriteCategorySchema)` to create a new message.
 */
export const FavoriteCategorySchema: GenMessage<FavoriteCategory> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 14);

/**
 * @generated from message konvo.user.preferences.v1.NagbarDismissals
 */
export type NagbarDismissals = Message<"konvo.user.preferences.v1.NagbarDismissals"> & {
  /**
   * @generated from field: bool ios_install = 1;
   */
  iosInstall: boolean;

  /**
   * @generated from field: bool pwa_install = 2;
   */
  pwaInstall: boolean;

  /**
   * @generated from field: bool push_notification = 3;
   */
  pushNotification: boolean;

  /**
   * @generated from field: bool desktop_notification = 4;
   */
  desktopNotification: boolean;

  /**
   * @generated from field: bool premium_grace_period = 5;
   */
  premiumGracePeriod: boolean;

  /**
   * @generated from field: bool premium_expired = 6;
   */
  premiumExpired: boolean;

  /**
   * @generated from field: bool premium_onboarding = 7;
   */
  premiumOnboarding: boolean;

  /**
   * @generated from field: bool premium_trial_expiring = 8;
   */
  premiumTrialExpiring: boolean;

  /**
   * @generated from field: bool gift_inventory = 9;
   */
  giftInventory: boolean;

  /**
   * @generated from field: bool desktop_download = 10;
   */
  desktopDownload: boolean;

  /**
   * @generated from field: bool guild_membership_cta = 11;
   */
  guildMembershipCta: boolean;

  /**
   * @generated from field: bool visionary_mfa = 12;
   */
  visionaryMfa: boolean;

  /**
   * @generated from field: bool legacy_phone_unlink = 14;
   */
  legacyPhoneUnlink: boolean;

  /**
   * @generated from field: map<string, bool> pending_bulk_deletion = 15;
   */
  pendingBulkDeletion: { [key: string]: boolean };

  /**
   * @generated from field: map<string, bool> invites_disabled = 16;
   */
  invitesDisabled: { [key: string]: boolean };

  /**
   * @generated from field: map<string, bool> guild_mfa_requirement = 17;
   */
  guildMfaRequirement: { [key: string]: boolean };
};

/**
 * Describes the message konvo.user.preferences.v1.NagbarDismissals.
 * Use `create(NagbarDismissalsSchema)` to create a new message.
 */
export const NagbarDismissalsSchema: GenMessage<NagbarDismissals> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 15);

/**
 * @generated from message konvo.user.preferences.v1.DismissedUpsells
 */
export type DismissedUpsells = Message<"konvo.user.preferences.v1.DismissedUpsells"> & {
  /**
   * @generated from field: bool picker_premium = 1;
   */
  pickerPremium: boolean;
};

/**
 * Describes the message konvo.user.preferences.v1.DismissedUpsells.
 * Use `create(DismissedUpsellsSchema)` to create a new message.
 */
export const DismissedUpsellsSchema: GenMessage<DismissedUpsells> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 16);

/**
 * @generated from message konvo.user.preferences.v1.GuildNsfwAgreements
 */
export type GuildNsfwAgreements = Message<"konvo.user.preferences.v1.GuildNsfwAgreements"> & {
  /**
   * @generated from field: repeated string agreed_channel_ids = 1;
   */
  agreedChannelIds: string[];

  /**
   * @generated from field: repeated string agreed_guild_ids = 2;
   */
  agreedGuildIds: string[];

  /**
   * @generated from field: repeated string agreed_category_ids = 3;
   */
  agreedCategoryIds: string[];
};

/**
 * Describes the message konvo.user.preferences.v1.GuildNsfwAgreements.
 * Use `create(GuildNsfwAgreementsSchema)` to create a new message.
 */
export const GuildNsfwAgreementsSchema: GenMessage<GuildNsfwAgreements> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 17);

/**
 * @generated from message konvo.user.preferences.v1.WhatsNewState
 */
export type WhatsNewState = Message<"konvo.user.preferences.v1.WhatsNewState"> & {
  /**
   * @generated from field: optional string last_dismissed_entry_id = 1;
   */
  lastDismissedEntryId?: string | undefined;
};

/**
 * Describes the message konvo.user.preferences.v1.WhatsNewState.
 * Use `create(WhatsNewStateSchema)` to create a new message.
 */
export const WhatsNewStateSchema: GenMessage<WhatsNewState> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 18);

/**
 * @generated from message konvo.user.preferences.v1.PermissionLayoutSettings
 */
export type PermissionLayoutSettings = Message<"konvo.user.preferences.v1.PermissionLayoutSettings"> & {
  /**
   * @generated from field: konvo.user.preferences.v1.PermissionLayoutMode layout = 1;
   */
  layout: PermissionLayoutMode;

  /**
   * @generated from field: konvo.user.preferences.v1.PermissionGridMode grid = 2;
   */
  grid: PermissionGridMode;
};

/**
 * Describes the message konvo.user.preferences.v1.PermissionLayoutSettings.
 * Use `create(PermissionLayoutSettingsSchema)` to create a new message.
 */
export const PermissionLayoutSettingsSchema: GenMessage<PermissionLayoutSettings> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 19);

/**
 * @generated from message konvo.user.preferences.v1.GuildMemberLayoutSettings
 */
export type GuildMemberLayoutSettings = Message<"konvo.user.preferences.v1.GuildMemberLayoutSettings"> & {
  /**
   * @generated from field: konvo.user.preferences.v1.GuildMemberViewMode mode = 1;
   */
  mode: GuildMemberViewMode;
};

/**
 * Describes the message konvo.user.preferences.v1.GuildMemberLayoutSettings.
 * Use `create(GuildMemberLayoutSettingsSchema)` to create a new message.
 */
export const GuildMemberLayoutSettingsSchema: GenMessage<GuildMemberLayoutSettings> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 20);

/**
 * @generated from message konvo.user.preferences.v1.GuildFolderExpandedState
 */
export type GuildFolderExpandedState = Message<"konvo.user.preferences.v1.GuildFolderExpandedState"> & {
  /**
   * @generated from field: repeated fixed64 expanded_folder_ids = 1;
   */
  expandedFolderIds: bigint[];
};

/**
 * Describes the message konvo.user.preferences.v1.GuildFolderExpandedState.
 * Use `create(GuildFolderExpandedStateSchema)` to create a new message.
 */
export const GuildFolderExpandedStateSchema: GenMessage<GuildFolderExpandedState> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 21);

/**
 * @generated from message konvo.user.preferences.v1.HiddenGuildListButtons
 */
export type HiddenGuildListButtons = Message<"konvo.user.preferences.v1.HiddenGuildListButtons"> & {
  /**
   * @generated from field: bool download_button = 1;
   */
  downloadButton: boolean;

  /**
   * @generated from field: bool help_button = 2;
   */
  helpButton: boolean;
};

/**
 * Describes the message konvo.user.preferences.v1.HiddenGuildListButtons.
 * Use `create(HiddenGuildListButtonsSchema)` to create a new message.
 */
export const HiddenGuildListButtonsSchema: GenMessage<HiddenGuildListButtons> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 22);

/**
 * @generated from message konvo.user.preferences.v1.KeyboardModeIntroState
 */
export type KeyboardModeIntroState = Message<"konvo.user.preferences.v1.KeyboardModeIntroState"> & {
  /**
   * @generated from field: bool seen = 1;
   */
  seen: boolean;
};

/**
 * Describes the message konvo.user.preferences.v1.KeyboardModeIntroState.
 * Use `create(KeyboardModeIntroStateSchema)` to create a new message.
 */
export const KeyboardModeIntroStateSchema: GenMessage<KeyboardModeIntroState> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 23);

/**
 * @generated from message konvo.user.preferences.v1.InputMonitoringPromptsState
 */
export type InputMonitoringPromptsState = Message<"konvo.user.preferences.v1.InputMonitoringPromptsState"> & {
  /**
   * @generated from field: bool seen_cta = 1;
   */
  seenCta: boolean;
};

/**
 * Describes the message konvo.user.preferences.v1.InputMonitoringPromptsState.
 * Use `create(InputMonitoringPromptsStateSchema)` to create a new message.
 */
export const InputMonitoringPromptsStateSchema: GenMessage<InputMonitoringPromptsState> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 24);

/**
 * @generated from message konvo.user.preferences.v1.VoicePromptsState
 */
export type VoicePromptsState = Message<"konvo.user.preferences.v1.VoicePromptsState"> & {
  /**
   * @generated from field: bool skip_hide_own_camera_confirm = 1;
   */
  skipHideOwnCameraConfirm: boolean;

  /**
   * @generated from field: bool skip_hide_own_screenshare_confirm = 2;
   */
  skipHideOwnScreenshareConfirm: boolean;
};

/**
 * Describes the message konvo.user.preferences.v1.VoicePromptsState.
 * Use `create(VoicePromptsStateSchema)` to create a new message.
 */
export const VoicePromptsStateSchema: GenMessage<VoicePromptsState> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 25);

/**
 * @generated from message konvo.user.preferences.v1.SudoPromptState
 */
export type SudoPromptState = Message<"konvo.user.preferences.v1.SudoPromptState"> & {
  /**
   * @generated from field: optional konvo.user.preferences.v1.MfaMethod last_used_mfa_method = 1;
   */
  lastUsedMfaMethod?: MfaMethod | undefined;
};

/**
 * Describes the message konvo.user.preferences.v1.SudoPromptState.
 * Use `create(SudoPromptStateSchema)` to create a new message.
 */
export const SudoPromptStateSchema: GenMessage<SudoPromptState> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 26);

/**
 * @generated from message konvo.user.preferences.v1.KeybindSettings
 */
export type KeybindSettings = Message<"konvo.user.preferences.v1.KeybindSettings"> & {
  /**
   * @generated from field: repeated konvo.user.preferences.v1.CustomKeybind custom_keybinds = 1;
   */
  customKeybinds: CustomKeybind[];

  /**
   * @generated from field: string transmit_mode = 2;
   */
  transmitMode: string;

  /**
   * @generated from field: optional uint32 push_to_talk_release_delay_ms = 3;
   */
  pushToTalkReleaseDelayMs?: number | undefined;
};

/**
 * Describes the message konvo.user.preferences.v1.KeybindSettings.
 * Use `create(KeybindSettingsSchema)` to create a new message.
 */
export const KeybindSettingsSchema: GenMessage<KeybindSettings> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 27);

/**
 * @generated from message konvo.user.preferences.v1.CustomKeybind
 */
export type CustomKeybind = Message<"konvo.user.preferences.v1.CustomKeybind"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string action = 2;
   */
  action?: string | undefined;

  /**
   * @generated from field: konvo.user.preferences.v1.KeybindCombo combo = 3;
   */
  combo?: KeybindCombo | undefined;

  /**
   * @generated from field: bool enabled = 4;
   */
  enabled: boolean;
};

/**
 * Describes the message konvo.user.preferences.v1.CustomKeybind.
 * Use `create(CustomKeybindSchema)` to create a new message.
 */
export const CustomKeybindSchema: GenMessage<CustomKeybind> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 28);

/**
 * @generated from message konvo.user.preferences.v1.KeybindCombo
 */
export type KeybindCombo = Message<"konvo.user.preferences.v1.KeybindCombo"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: optional string code = 2;
   */
  code?: string | undefined;

  /**
   * @generated from field: bool ctrl_or_meta = 3;
   */
  ctrlOrMeta: boolean;

  /**
   * @generated from field: bool ctrl = 4;
   */
  ctrl: boolean;

  /**
   * @generated from field: bool alt = 5;
   */
  alt: boolean;

  /**
   * @generated from field: bool shift = 6;
   */
  shift: boolean;

  /**
   * @generated from field: bool meta = 7;
   */
  meta: boolean;

  /**
   * @generated from field: optional bool global = 8;
   */
  global?: boolean | undefined;

  /**
   * @generated from field: optional bool enabled = 9;
   */
  enabled?: boolean | undefined;

  /**
   * @generated from field: bool modifier_only = 10;
   */
  modifierOnly: boolean;

  /**
   * @generated from field: bool both_sides = 11;
   */
  bothSides: boolean;

  /**
   * @generated from field: optional uint32 mouse_button = 12;
   */
  mouseButton?: number | undefined;

  /**
   * @generated from field: optional uint32 gamepad_button = 13;
   */
  gamepadButton?: number | undefined;
};

/**
 * Describes the message konvo.user.preferences.v1.KeybindCombo.
 * Use `create(KeybindComboSchema)` to create a new message.
 */
export const KeybindComboSchema: GenMessage<KeybindCombo> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 29);

/**
 * @generated from message konvo.user.preferences.v1.ChatInputSettings
 */
export type ChatInputSettings = Message<"konvo.user.preferences.v1.ChatInputSettings"> & {
  /**
   * @generated from field: optional bool convert_emoticons = 1;
   */
  convertEmoticons?: boolean | undefined;
};

/**
 * Describes the message konvo.user.preferences.v1.ChatInputSettings.
 * Use `create(ChatInputSettingsSchema)` to create a new message.
 */
export const ChatInputSettingsSchema: GenMessage<ChatInputSettings> = /*@__PURE__*/
  messageDesc(file_konvo_user_preferences_v1_preferences, 30);

/**
 * @generated from enum konvo.user.preferences.v1.PermissionLayoutMode
 */
export enum PermissionLayoutMode {
  /**
   * @generated from enum value: PERMISSION_LAYOUT_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PERMISSION_LAYOUT_MODE_COMFY = 1;
   */
  COMFY = 1,

  /**
   * @generated from enum value: PERMISSION_LAYOUT_MODE_DENSE = 2;
   */
  DENSE = 2,
}

/**
 * Describes the enum konvo.user.preferences.v1.PermissionLayoutMode.
 */
export const PermissionLayoutModeSchema: GenEnum<PermissionLayoutMode> = /*@__PURE__*/
  enumDesc(file_konvo_user_preferences_v1_preferences, 0);

/**
 * @generated from enum konvo.user.preferences.v1.PermissionGridMode
 */
export enum PermissionGridMode {
  /**
   * @generated from enum value: PERMISSION_GRID_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PERMISSION_GRID_MODE_SINGLE = 1;
   */
  SINGLE = 1,

  /**
   * @generated from enum value: PERMISSION_GRID_MODE_GRID = 2;
   */
  GRID = 2,
}

/**
 * Describes the enum konvo.user.preferences.v1.PermissionGridMode.
 */
export const PermissionGridModeSchema: GenEnum<PermissionGridMode> = /*@__PURE__*/
  enumDesc(file_konvo_user_preferences_v1_preferences, 1);

/**
 * @generated from enum konvo.user.preferences.v1.GuildMemberViewMode
 */
export enum GuildMemberViewMode {
  /**
   * @generated from enum value: GUILD_MEMBER_VIEW_MODE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: GUILD_MEMBER_VIEW_MODE_TABLE = 1;
   */
  TABLE = 1,

  /**
   * @generated from enum value: GUILD_MEMBER_VIEW_MODE_GRID = 2;
   */
  GRID = 2,
}

/**
 * Describes the enum konvo.user.preferences.v1.GuildMemberViewMode.
 */
export const GuildMemberViewModeSchema: GenEnum<GuildMemberViewMode> = /*@__PURE__*/
  enumDesc(file_konvo_user_preferences_v1_preferences, 2);

/**
 * @generated from enum konvo.user.preferences.v1.MfaMethod
 */
export enum MfaMethod {
  /**
   * @generated from enum value: MFA_METHOD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MFA_METHOD_TOTP = 1;
   */
  TOTP = 1,

  /**
   * @generated from enum value: MFA_METHOD_WEBAUTHN = 3;
   */
  WEBAUTHN = 3,
}

/**
 * Describes the enum konvo.user.preferences.v1.MfaMethod.
 */
export const MfaMethodSchema: GenEnum<MfaMethod> = /*@__PURE__*/
  enumDesc(file_konvo_user_preferences_v1_preferences, 3);

